import { FARM_CLIENT, FARM_V2_CLIENT } from 'config/constants/endpoints'
import {
  UserCraftsmansRecord,
  UserCraftsmansResponse,
  UserHarvestedRecord,
  UserHarvestedResponse,
  UserHarvestedRewarderV2Record,
  UserHarvestedV2Response,
} from 'config/constants/types'
import request, { gql } from 'graphql-request'

export const getUsersHarvestedData = async (
  address: string,
): Promise<{ user?: UserHarvestedRecord; error: boolean }> => {
  try {
    const query = gql`
      query users($address: Bytes!) {
        users(where: { id: $address }) {
          totalClaimAmount
          totalVVSVaultProfit
        }
      }
    `
    const { users } = await request<UserHarvestedResponse>(FARM_CLIENT, query, {
      address: address.toLowerCase(),
    })
    if (!users || users.length !== 1) throw new Error('received data not valid')
    return { user: users[0], error: false }
  } catch (error) {
    console.error('Failed to fetch users harvested data', error)
    return { error: true }
  }
}

export const getUsersHarvestedV2Data = async (
  address: string,
): Promise<{ user?: UserHarvestedRecord; userRewarders?: UserHarvestedRewarderV2Record[]; error: boolean }> => {
  try {
    const query = gql`
      query users($address: Bytes!) {
        users(where: { id: $address }) {
          totalClaimAmount
        }
        userCraftsmanRewarders(where: { user: $address }) {
          rewarder {
            rewardToken
            rewardTokenDecimal
          }
          rewardTokenClaimed
        }
      }
    `

    const { users, userCraftsmanRewarders } = await request<UserHarvestedV2Response>(FARM_V2_CLIENT, query, {
      address: address.toLowerCase(),
    })

    if (!users || users.length !== 1) throw new Error('received data not valid')
    return { user: users[0], userRewarders: userCraftsmanRewarders, error: false }
  } catch (error) {
    console.error('Failed to fetch users harvested V2 data', error)
    return { error: true }
  }
}

export const getUserCraftsmansData = async (
  address: string,
  pidInput: number,
): Promise<{ data?: UserCraftsmansRecord; error: boolean }> => {
  try {
    const query = gql`
      query userCraftsmans($address: Bytes!, $pidInput: Int!) {
        userCraftsmans(where: { user: $address, pid: $pidInput }) {
          amount0Supplied
          amount1Supplied
          avgAmount0Price
          avgAmount1Price
          totalVVSClaimed
        }
      }
    `
    const { userCraftsmans } = await request<UserCraftsmansResponse>(FARM_CLIENT, query, {
      address: address.toLowerCase(),
      pidInput,
    })
    if (userCraftsmans && userCraftsmans.length === 1) {
      return { data: userCraftsmans[0], error: false }
    }
    return { error: true }
  } catch (error) {
    console.error('Failed to fetch user craftsmans data', error)
    return { error: true }
  }
}

export const getUserCraftsmansV2Data = async (
  address: string,
  pidInput: number,
): Promise<{ data?: UserCraftsmansRecord; error: boolean }> => {
  try {
    const query = gql`
      query userCraftsmans($address: Bytes!, $pidInput: Int!) {
        userCraftsmans(where: { user: $address, pid: $pidInput }) {
          amount0Supplied
          amount1Supplied
          avgAmount0Price
          avgAmount1Price
          totalVVSClaimed
        }
      }
    `
    const { userCraftsmans } = await request<UserCraftsmansResponse>(FARM_V2_CLIENT, query, {
      address: address.toLowerCase(),
      pidInput,
    })
    if (userCraftsmans && userCraftsmans.length === 1) {
      return { data: userCraftsmans[0], error: false }
    }
    return { error: true }
  } catch (error) {
    console.error('Failed to fetch user craftsmans V2 data', error)
    return { error: true }
  }
}
